// © Microsoft Corporation. All rights reserved.
/* eslint-disable react/display-name */
import React, { useState, useEffect } from 'react';
import { Label, Overlay, Stack } from '@fluentui/react';
import Header from '../containers/Header';
import MediaGallery from '../containers/MediaGallery';
import MediaFullScreen from './MediaFullScreen';
import CommandPanel, { CommandPanelTypes } from './CommandPanel';
import { Constants } from '../core/constants';
import WaitingScreen from './WaitingScreen';
import 'bootstrap/dist/css/bootstrap.css';
import appconfig from '../appconfig.json';
import axios from 'axios';
import setLanguage, { translations } from 'translation';
import {
  headerStyles,
  containerStyles,
  paneStyles,
  hiddenContainerClassName,
  activeContainerClassName,
  loadingStyle,
  overlayStyles
} from './styles/GroupCall.styles';
import {
  Call,
  LocalVideoStream,
  AudioDeviceInfo,
  VideoDeviceInfo,
  RemoteParticipant,
  CallAgent,
  DeviceManager,
  CallEndReason
} from '@azure/communication-calling';
import { ParticipantStream } from 'core/reducers/index.js';
import { ChatClient, ChatThreadClient } from '@azure/communication-chat';
import { store } from 'App';
//import WaitingScreenNewGosi from './WaitingScreenNewGosi';
//import { initializeSpeechRecognition } from '../Utils/speech-recognition';

export interface GroupCallProps {
  userId: string;
  displayName: string;
  userToken: string;
  groupId: string;
  call: Call;
  callAgent: CallAgent;
  chatClient: ChatClient;
  deviceManager: DeviceManager;
  mic: boolean;
  remoteParticipants: RemoteParticipant[];
  callState: string;
  localVideo: boolean;
  localVideoStream: LocalVideoStream;
  screenShareStreams: ParticipantStream[];
  audioDeviceInfo: AudioDeviceInfo;
  videoDeviceInfo: VideoDeviceInfo;
  audioDeviceList: AudioDeviceInfo[];
  videoDeviceList: VideoDeviceInfo[];
  screenWidth: number;
  shareScreen: boolean;
  setAudioDeviceInfo(deviceInfo: AudioDeviceInfo): void;
  setVideoDeviceInfo(deviceInfo: VideoDeviceInfo): void;
  setLocalVideoStream(stream: LocalVideoStream | undefined): void;
  mute(): void;
  enableMic(): void;
  isGroup(): void;
  joinGroup(): void;
  endCallHandler(): void;

  setupCallClient(unsupportedStateHandler: () => void): void;
  setupCallAgent(displayName: string): void;
  setGroup(groupId: string): void;
  startCallHandler(): void;
  unsupportedStateHandler: () => void;
  callEndedHandler: (reason: CallEndReason) => void;
  setMic(mic: boolean): void;
  receivedChatMessage: string;
  allMessages: any;
  serverCallId: string;
  otpToken: string;
  meetingID: string;
  serviceType: string;
}

let allMessages: string;
let localProps: GroupCallProps;
export default (props: GroupCallProps): JSX.Element => {
  localProps = props;
  const [selectedPane, setSelectedPane] = useState(CommandPanelTypes.None);
  //const [receivedChatMessage, setReceivedChatMessage] = useState(props.receivedChatMessage);
  const activeScreenShare = props.screenShareStreams && props.screenShareStreams.length === 1;

  const { callAgent, call, setGroup, joinGroup, setupCallAgent, setupCallClient, unsupportedStateHandler } = props;
  const queryParams = new URLSearchParams(window.location.search);
  const meetingLink = queryParams.get('meetingLink');
  // const [captions, setCaptions] = useState<string[]>([]);
  // const [currentCaption, setCurrentCaption] = useState<string>('');
  // const recognitionRef = React.useRef<any | null>(null);

  // const startRecognition = () => {
  //   // recognitionRef.current = initializeSpeechRecognition(onResult, onError, onEnd);
  //   // if (recognitionRef.current) {
  //   //   recognitionRef.current.start();
  //   // }
  // };

  // const onResult = (event: any) => {
  //   let interimTranscript = '';
  //   let finalTranscript = '';

  //   for (let i = event.resultIndex; i < event.results.length; ++i) {
  //     if (event.results[i].isFinal) {
  //       finalTranscript += event.results[i][0].transcript;
  //     } else {
  //       interimTranscript += event.results[i][0].transcript;
  //     }
  //   }

  //   setCurrentCaption(interimTranscript);
  //   if (finalTranscript) {
  //     setCaptions((prevCaptions) => [...prevCaptions, finalTranscript]);
  //   }
  // };

  // const onError = (event: any) => {
  //   console.error("Speech recognition error", event.error);
  // };

  // const onEnd = () => {
  //   console.log("Speech recognition service disconnected, restarting...");
  //   startRecognition(); // Restart the recognition service
  // };

  // useEffect(() => {
  //   startRecognition();

  //   return () => {
  //     if (recognitionRef.current) {
  //       recognitionRef.current.stop();
  //     }
  //   };
  // }, []);

  //const fullname = queryParams.get("fullname");
  let common = store.getState().common;
  let fullName = common.fullName;
  if (fullName == null || fullName == undefined) {
    fullName = '';
  }

  useEffect(() => {
    setupCallClient(unsupportedStateHandler);
    setupCallAgent(fullName == null ? '' : fullName);
  }, []);

  useEffect(() => {
    props.setMic(true);
    setGroup(meetingLink == null ? '' : meetingLink);
  }, [setupCallClient, unsupportedStateHandler]);

  useEffect(() => {
    if (callAgent && !call) {
      joinGroup();
    }
  }, [callAgent, call, joinGroup]);
  if (props.serverCallId) {
    //alert("Server Call ID = "+props.serverCallId);
  }

  return (
    <Stack horizontalAlign="center" verticalAlign="center" styles={containerStyles}>
      <Stack.Item styles={headerStyles}>
        <Header
          selectedPane={selectedPane}
          setSelectedPane={setSelectedPane}
          endCallHandler={() => {
            props.endCallHandler();
          }}
          screenWidth={props.screenWidth}
        />
      </Stack.Item>

      {/* <div>
        <div>
          <h3>Captions:</h3>
          <p>{currentCaption}</p>
          <ul>
            {captions.map((caption, index) => (
              <li key={index}>{caption}</li>
            ))}
          </ul>
        </div>
      </div> */}

      <Stack.Item styles={containerStyles}>
        {!props.shareScreen ? (
          props.callState === Constants.CONNECTED ? (
            <>
              <Stack horizontal styles={containerStyles}>
                {activeScreenShare && (
                  <Stack.Item grow styles={activeScreenShare ? activeContainerClassName : hiddenContainerClassName}>
                    {activeScreenShare && <MediaFullScreen activeScreenShareStream={props.screenShareStreams[0]} />}
                  </Stack.Item>
                )}
                {!activeScreenShare && (
                  <Stack.Item grow styles={!activeScreenShare ? activeContainerClassName : hiddenContainerClassName}>
                    <MediaGallery />
                  </Stack.Item>
                )}
                {selectedPane !== CommandPanelTypes.None &&
                  (window.innerWidth > Constants.MINI_HEADER_WINDOW_WIDTH ? (
                    <Stack.Item disableShrink styles={paneStyles}>
                      <CommandPanel {...props} selectedPane={selectedPane} setSelectedPane={setSelectedPane} />
                    </Stack.Item>
                  ) : (
                    <Overlay styles={overlayStyles} style={{minHeight:"500px"}}>
                      <CommandPanel {...props} selectedPane={selectedPane} setSelectedPane={setSelectedPane} />
                    </Overlay>
                  ))}
              </Stack>
            </>
          ) : (
            <div>
              {/*<Label>you are waiting in the queue</Label>  1111*/}
              {/* {props.serviceType == 'new-gosi' ? (
                <WaitingScreenNewGosi></WaitingScreenNewGosi>
              ) : ( */}
              <WaitingScreen></WaitingScreen>
              {/* )} */}
            </div>
          )
        ) : (
          <div className={loadingStyle}>
            <Label>Your screen is being shared</Label>
          </div>
        )}
      </Stack.Item>
    </Stack>
  );
};

export interface ChatProps {
  fileSelected: string;
  isFilePicked: boolean;
}

export class ChatFeature extends React.Component {
  chatThreadClient: ChatThreadClient | undefined;
  chatAgentData: any;

  componentDidMount() {
    this.initiateChatClient();
    if (localProps?.receivedChatMessage != null) {
      let message = localProps.receivedChatMessage;
      message = message.replace('<p>', '');
      message = message.replace('</p>', '');
      const formattedMessage = "<div class='received-message'>" + message + '</div>';
      this.setState({
        message: '',
        messages: this.state.messages + '<br>' + formattedMessage
      });
    }

    if (allMessages) {
      this.setState({
        message: '',
        messages: allMessages
      });
    }

    document.getElementById('chat_message_box')?.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        this.handleSendMessage();
      }
    });
  }

  componentDidUpdate() {
    allMessages = this.state.messages;
    let language = localStorage.getItem('lang');
    let iconFileUpload = document.querySelector('.bi.bi-paperclip') as HTMLInputElement;

    let selectorTextbox = document.getElementById('chat_message_box') as HTMLInputElement;
    if (language === 'en') {
      iconFileUpload.style.right = '1px';
      selectorTextbox.style.marginLeft = '26px';
      selectorTextbox.style.marginRight = '0px';
    } else {
      iconFileUpload.style.right = 'inherit';
    }
    setLanguage(language);
    //this.setState({
    //    language: language,

    //})
  }

  initiateChatClient = async () => {
    const chatClient = localProps.chatClient;

    //await chatClient.startRealtimeNotifications();
    const groupIdArr = localProps.groupId.split('/');
    const threadId = groupIdArr[5];
    console.log('initiateChatClient threadId = ' + threadId);
    chatClient.on('chatMessageReceived', (e: any) => {
      console.log(e.message, this.state.messages, 'Notification chatMessageReceived!');
      if (e.sender.communicationUserId != localProps.userId) {
        this.renderReceivedMessage(e.message, e.sender.communicationUserId);
      } else {
        this.renderSentMessage(e.message, localProps.userId);
      }
    });
    this.chatThreadClient = await chatClient.getChatThreadClient(threadId);
  };

  state = {
    messages: '',
    message: '',
    language: ''
  };
  handleMessageChange = (event: any) => {
    this.setState({
      message: event.target.value,
      messages: this.state.messages
    });
  };

  handleSendMessage = async () => {
    this.chatThreadClient?.getProperties();
    let sendMessageRequest = { content: this.state.message };
    let sendMessageOptions = { senderDisplayName: localProps.displayName };
    try {
      await this.chatThreadClient?.sendMessage(sendMessageRequest, sendMessageOptions);
    } catch (err) {
      alert(err);
      /* let error: string = JSON.stringify(err);
            if (error.includes("Forbbiden")) {
                this.initiateChatClient();
                await this.chatThreadClient.sendMessage(sendMessageRequest, sendMessageOptions);
            } */
    }
    this.setState({
      message: '',
      messages: this.state.messages
    });
  };

  renderReceivedMessage = async (message: string, user: string) => {
    console.log(message, 'renderReceivedMessage');
    message = message.replace('<p>', '');
    message = message.replace('</p>', '');
    const formattedMessage = "<div class='received-message'>" + message + '</div>';
    this.setState({
      message: '',
      messages: this.state.messages + '<br>' + formattedMessage
    });

    this.updateScroll();
  };

  renderSentMessage = async (message: string, user: string) => {
    console.log(message, 'renderSentMessage');
    const formattedMessage = "<div class='sent-message'>" + message + '</div>';
    this.setState({
      message: '',
      messages: this.state.messages + '<br>' + formattedMessage
    });
    this.updateScroll();
  };

  updateScroll() {
    let element = document.getElementById('messages-container') as HTMLElement;
    if (element) {
      element.scrollTop = element.scrollHeight - 100;
    }
  }

  submitFile = (event: any) => {
    const languageSelector = document.getElementById('languageSelector') as HTMLInputElement;
    let language = languageSelector.value;
    //this.saveFileURL("http://10.0.43.204:8000/objectstore/api/objects/2373fc13-146d-48f2-8d5f-4e4d140bc715test.pdf");
    const formData = new FormData();
    const selectedFile: File = event.target.files[0];
    const allowedFileExtensions = ['pdf', 'jpeg', 'png', 'jpg'];
    /*  alert("File Name = "+selectedFile.name);
         alert("File Size = "+selectedFile.size);
         alert("File Type = "+selectedFile.type);
  */
    var ext = selectedFile.name.split('.')[1];
    if (!allowedFileExtensions.includes(ext)) {
      //alert("Allowed file types are ['pdf','jpeg','png','jpg']")
      alert((translations as any)[language]['fileTypeAlert']);
      return false;
    } else if (selectedFile.size > 4097152) {
      //alert("Max. file size is 2M")
      alert((translations as any)[language]['fileSizeAlert']);
      return false;
    }
    formData.append('file', selectedFile);
    formData.append('callId', localProps.meetingID);
    const requestOptions = {
      method: 'POST',
      // headers: myHeaders,
      body: formData
    };
    const url = appconfig.azure_reports_url + '/Attatchment/customer/upload';
    //'https://gosionlinedev.gosi.ins/webapi/objectstore/api/uploadfile/',
    //const url = appconfig.file_upload_server+"/objectstore/api/uploadfile/";
    fetch(url, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        //alert(JSON.stringify(result))
        //this.saveFileURL(result.link);
        console.log('Share file success response:', result);
        /*  this.setState({
                     message: result.link
                 }); */
        this.setState({
          message: (translations as any)[language]['fileShare']
        });
        this.handleSendMessage();
        let uploadFileBtn = document.getElementById('uploadFileBtn') as HTMLInputElement;
        uploadFileBtn.value = '';
      })
      .catch((error) => {
        alert('Error:' + JSON.stringify(error));
        console.error('Error:', error);
      });
    return true;
  };

  saveFileURL = (fileurl: string) => {
    const requestBody = {
      Attachments: [fileurl]
    };

    let common = store.getState().common;
    const config = {
      headers: {
        api_token: common.token
      }
    };
    // alert(JSON.stringify(requestBody));
    //https://gosivvas-report-api-uat.azurewebsites.net/api/addattachment/06191951-be2f-43ed-a382-0b9095e8c2ad
    const url = appconfig.azure_reports_url + '/api/addattachment/' + localProps.meetingID;
    axios
      .post(url, requestBody, config)
      .then((response) => {
        // alert(JSON.stringify(response));
        console.log('saveFileUrl msg = ' + response);
      })
      .catch((error) => {
        alert(JSON.stringify(error));
      });
  };

  openFileAppload = () => {
    let uploadFileBtn = document.getElementById('uploadFileBtn') as HTMLInputElement;
    uploadFileBtn.click();
  };
  // , height: "95vh",overflow: "scroll"
  render() {
   
    if (localProps.callState === Constants.CONNECTED) {
      return (
        <div>
          <div className="chat-container" style={{ backgroundColor: '#fff' }}>
            <div className="chat-container-2">
              <div className="chat-popup">
                <div>
                  <div id="messages-container">
                    {localProps?.allMessages && localProps?.allMessages.length > 0 && localProps?.allMessages.map((msg: any) => {
                      return (
                        <>
                          <div
                            className={msg?.messageType == 'sent' ? 'sent-message' : 'received-message'}
                            dangerouslySetInnerHTML={{ __html: msg?.message }}
                          />
                          <br />
                        </>
                      );
                    })}
                  </div>
                </div>
                <div>
                  <form className="form-container">
                    <div className="chatRow">
                      {/* style={{right: this.state.language === "en" ? "1px" : "inherit"}} */}
                      <i className="bi bi-paperclip btn-link" onClick={this.openFileAppload}></i>
                      <input
                        type="file"
                        name="file"
                        style={{ display: 'none' }}
                        id="uploadFileBtn"
                        onChange={this.submitFile}
                        className="filestyle"
                        data-classButton="btn btn-primary"
                        data-input="false"
                        data-classIcon="icon-plus"
                        data-buttonText="d"
                      />
                      <textarea
                        placeholder="اكتب هنا..."
                        data-i18n="chatPlaceholder"
                        onChange={this.handleMessageChange}
                        value={this.state.message}
                        name="chat_message_box"
                        id="chat_message_box"
                        required
                      ></textarea>
                      <button type="button" onClick={this.handleSendMessage} data-i18n="save_btn">
                        ارسال
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return <div>There is no active calls</div>;
    }
  }
}
